export const ENTRY_POINTS = {
  VTP: 'vtp',
  GLC: 'glc',
  OMNICHANNEL: 'omnichannel',
}

export const ENTRY_POINT_URLS_PART = {
  VTP: process.env.REACT_APP_STAGING_ENV === 'prod' ? 'stock-locator' : 'vtp',
  OMNICHANNEL: 'vwfs.financeapplication',
  GLC: [
    'vw.financeapplication',
    'vwcv.financeapplication',
    'audi.financeapplication',
  ],
}

const checkForStockLocatorEntryPoint = () =>
  window.location.href.indexOf(ENTRY_POINT_URLS_PART.VTP) >= 0

const checkForOmnichannelEntryPoint = () =>
  window.location.href.indexOf(ENTRY_POINT_URLS_PART.OMNICHANNEL) >= 0

const checkForGlcEntryPoint = () =>
  ENTRY_POINT_URLS_PART.GLC.some(part => window.location.href.includes(part))

export const entrypointsUtils = () => {
  if (checkForStockLocatorEntryPoint()) return ENTRY_POINTS.VTP
  if (checkForOmnichannelEntryPoint()) return ENTRY_POINTS.OMNICHANNEL
  if (checkForGlcEntryPoint()) return ENTRY_POINTS.GLC

  return null
}
